import React from 'react'
import UsersList from './UsersList'

export default function ActiveUsersTab ({ activeUsers, deleteModal }) {
  return (
    <UsersList users={activeUsers} deleteModal={deleteModal} />
  )
}
